// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"8":"22ec791b54fa185632a9","226":"56358dd9a1f9d3211b20","877":"1586bbdbfa2f60419bed"}[chunkId] + ".js";
};